// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1N5On","content":"RecentSearches_content__3p7Z-"};